export default __webpack_public_path__ + "static/media/support.8ab8b6ef.pdf";